import { useState, useMemo } from 'react';

export function useFileManagerModalsState() {
  const [overrideFiles, setOverrideFiles] = useState(null);
  const [isContentSearchActive, setIsContentSearchActive] = useState(false);
  const [selectedItem, setSelectedItem] = useState();
  const [fileName, setFileName] = useState('');
  const [deletePermission, setDeletePermission] = useState(true);
  const [versionFileUpload, setVersionFileUpload] = useState(false);
  const [previewList, setPreviewList] = useState([]);
  const [selectedPreviewItem, setSelectedPreviewItem] = useState();
  const [valueSelected, setValueSelected] = useState(false);

  const [showEsignStatusModal, setEsignStatusModal] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [showAddTag, setShowAddTag] = useState(false);
  const [tagModalType, setTagModalType] = useState('');
  const [showShareFileModal, setShowShareFileModal] = useState(false);
  const [showRenameModal, setShowRenameModal] = useState(false);
  const [moveItemModal, setMoveItemModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showBulkDeleteModal, setShowBulkDeleteModal] = useState(false);
  const [showBulkMoveModal, setShowBulkMoveModal] = useState(false);
  const [isCopy, setIsCopy] = useState(false);
  const [showFileUploadModal, setShowFileUploadModal] = useState(false);
  const [showUploadedVersionsModal, setShowUploadedVersionsModal] = useState(false);
  const [showCreateFolderModal, setShowCreateFolderModal] = useState(false);
  const [showCreateDocumentModal, setShowCreateDocumentModal] = useState(false);
  const [showSignatureModal, setShowSignatureModal] = useState(false);
  const [globalTags, setGlobalTags] = useState(null);
  const [showSummarizeModal, setShowSummarizeModal] = useState(false);
  const [showConfigureSummaryModal, setShowConfigureSummaryModal] = useState(false);
  const [summaryData, setSummaryData] = useState(null);
  const [summaryVersions, setSummaryVersions] = useState({});
  const [summaryGenerationStatus, setSummaryGenerationStatus] = useState({});
  const [showCreateEventModal, setShowCreateEventModal] = useState(false);
  const [courtDateMsg, setCourtDateMsg] = useState(null);
  const [showSendFaxModal, setShowSendFaxModal] = useState(false);
  const [isFirmDocumentsUpload, setIsFirmDocumentsUpload] = useState(false);

  const resetContentSearch = () => {
    setOverrideFiles(null);
    setIsContentSearchActive(false);
  };

  const modals = useMemo(
    () => ({
      showPreview,
      setShowPreview,
      showRenameModal,
      setShowRenameModal,
      moveItemModal,
      setMoveItemModal,
      showDeleteModal,
      showBulkDeleteModal,
      showBulkMoveModal,
      setShowDeleteModal,
      setShowBulkDeleteModal,
      setShowBulkMoveModal,
      showShareFileModal,
      setShowShareFileModal,
      tagModalType,
      setTagModalType,
      showAddTag,
      setShowAddTag,
      showFileUploadModal,
      setShowFileUploadModal,
      showUploadedVersionsModal,
      setShowUploadedVersionsModal,
      showCreateFolderModal,
      setShowCreateFolderModal,
      showCreateDocumentModal,
      setShowCreateDocumentModal,
      showSignatureModal,
      setShowSignatureModal,
      isCopy,
      setIsCopy,
      setEsignStatusModal,
      showEsignStatusModal,
      showSummarizeModal,
      setShowSummarizeModal,
      showConfigureSummaryModal,
      setShowConfigureSummaryModal,
      showCreateEventModal,
      setShowCreateEventModal,
      showSendFaxModal,
      setShowSendFaxModal,
      isFirmDocumentsUpload,
      setIsFirmDocumentsUpload,
    }),
    [
      showPreview,
      showRenameModal,
      moveItemModal,
      showDeleteModal,
      showBulkDeleteModal,
      showBulkMoveModal,
      showShareFileModal,
      tagModalType,
      showAddTag,
      showFileUploadModal,
      showUploadedVersionsModal,
      showCreateFolderModal,
      showCreateDocumentModal,
      showSignatureModal,
      isCopy,
      showEsignStatusModal,
      showSummarizeModal,
      showConfigureSummaryModal,
      showCreateEventModal,
      showSendFaxModal,
      isFirmDocumentsUpload,
    ]
  );

  return {
    overrideFiles,
    setOverrideFiles,
    isContentSearchActive,
    setIsContentSearchActive,
    selectedItem,
    setSelectedItem,
    fileName,
    setFileName,
    deletePermission,
    setDeletePermission,
    versionFileUpload,
    setVersionFileUpload,
    previewList,
    setPreviewList,
    selectedPreviewItem,
    setSelectedPreviewItem,
    valueSelected,
    setValueSelected,
    showEsignStatusModal,
    setEsignStatusModal,
    showPreview,
    setShowPreview,
    showAddTag,
    setShowAddTag,
    tagModalType,
    setTagModalType,
    showShareFileModal,
    setShowShareFileModal,
    showRenameModal,
    setShowRenameModal,
    moveItemModal,
    setMoveItemModal,
    showDeleteModal,
    setShowDeleteModal,
    showBulkDeleteModal,
    setShowBulkDeleteModal,
    showBulkMoveModal,
    setShowBulkMoveModal,
    isCopy,
    setIsCopy,
    showFileUploadModal,
    setShowFileUploadModal,
    showUploadedVersionsModal,
    setShowUploadedVersionsModal,
    showCreateFolderModal,
    setShowCreateFolderModal,
    showCreateDocumentModal,
    setShowCreateDocumentModal,
    showSignatureModal,
    setShowSignatureModal,
    globalTags,
    setGlobalTags,
    showSummarizeModal,
    setShowSummarizeModal,
    showConfigureSummaryModal,
    setShowConfigureSummaryModal,
    summaryData,
    setSummaryData,
    summaryVersions,
    setSummaryVersions,
    summaryGenerationStatus,
    setSummaryGenerationStatus,
    showCreateEventModal,
    setShowCreateEventModal,
    courtDateMsg,
    setCourtDateMsg,
    showSendFaxModal,
    setShowSendFaxModal,
    isFirmDocumentsUpload,
    setIsFirmDocumentsUpload,
    resetContentSearch,
    modals,
  };
}

export default useFileManagerModalsState;
